import { backendServices } from '../..';
export interface IWorkflowRouting {
    canEdit: boolean | null;
    canGLCode: boolean | null;
    canEditPOFields: boolean | null;
    canReassign: boolean | null;
}

const defaultSettings = {
    canEdit: null,
    canGLCode: null,
    canEditPOFields: null,
    canReassign: null,
};

export const getDocumentWorkflowRouting = (
    workflow: backendServices.ViewModels.WorkflowViewModel | null | undefined,
    workflowActivityId: number | null | undefined,
    workFlowTaskCustomData: any
): IWorkflowRouting => {
    if (!workflow || !workflowActivityId || !workFlowTaskCustomData) {
        return defaultSettings;
    }

    const workflowKeywordRoutingApproversId = Number(
        workFlowTaskCustomData.TaskCustomData?.WorkflowKeywordRouting?.[0]?.ApprovalId?.[0]
    );

    if (typeof workflowKeywordRoutingApproversId !== 'number' || isNaN(workflowKeywordRoutingApproversId)) {
        return defaultSettings;
    }

    // As agreed with Matt Robertson, we need to use the KeywordRoutingId in the workflow task custom data to find the correct workflow routing
    const workflowKeywordRoutingId = Number(
        workFlowTaskCustomData.TaskCustomData?.WorkflowKeywordRouting?.[0]?.Id?.[0]
    );

    if (typeof workflowKeywordRoutingId !== 'number' || isNaN(workflowKeywordRoutingId)) {
        return defaultSettings;
    }

    const workflowRouting = workflow.WorkflowKeywordRoutings?.find(
        (routing) => routing.WorkflowActivityId === workflowActivityId && routing.Id === workflowKeywordRoutingId
    );

    if (!workflowRouting) {
        return defaultSettings;
    }

    const workflowKeywordRoutingApprovers = workflowRouting.WorkflowKeywordRoutingApprovers.find(
        (approver) => approver.Id === workflowKeywordRoutingApproversId
    );

    return {
        canEdit: workflowKeywordRoutingApprovers?.CanEditInvoice ?? null,
        canGLCode: workflowKeywordRoutingApprovers?.CanCodeInvoice ?? null,
        canEditPOFields: workflowKeywordRoutingApprovers?.CanEditPOFields ?? null,
        canReassign: workflowKeywordRoutingApprovers?.CanReassign ?? null,
    };
};

export const determineIfFieldPO = (fieldName: string) => {
    return (
        fieldName === 'PurchaseOrder' ||
        fieldName === 'PurchaseOrderNum' ||
        fieldName === 'POLineNumCalc' ||
        fieldName === 'PurchaseOrderLineNum' ||
        fieldName === 'MiscInfoXML'
    );
};
